// Carries a partner-invite token across the Kinde signup round-trip: the signed-out accept
// page (/partner-invite/accept?token=…) launches Kinde hosted registration, which leaves our
// origin and returns to /callback WITHOUT the token in the URL. We stash the token here before
// register() and consume it after /callback to bring the new user back to the accept page.
//
// Storage choice — localStorage, NOT sessionStorage: Kinde's email-verification step can
// complete in a SEPARATE browser tab (the user clicks a link in their inbox), where a
// per-tab sessionStorage entry wouldn't be visible; and the Kinde SDK itself persists PKCE
// state in localStorage (is_dangerously_use_local_storage). The { token, createdAt } envelope
// + short TTL + clear-on-consume keep this bearer-ish value short-lived despite localStorage.
const KEY = 'pendingPartnerInvite';
const TTL_MS = 20 * 60 * 1000; // 20 min — generous for a signup + email-verify round-trip, still short-lived
const ACCEPT_PATH = '/partner-invite/accept'; // the accept page route (must match Navigation route + the invite email link)

/** Full-page navigate to the partner accept page carrying the token (single seam for the route + encoding). */
export const redirectToPartnerInviteAccept = (token) => {
	window.location.replace(`${ACCEPT_PATH}?token=${encodeURIComponent(token)}`);
};

export const savePendingPartnerInvite = (token) => {
	if (!token) return;
	try {
		localStorage.setItem(KEY, JSON.stringify({ token, createdAt: Date.now() }));
	} catch {
		// storage unavailable (private mode / quota) — non-fatal; the flow degrades to the
		// "reopen the link after signing in" path.
	}
};

/** The stored token if present and within TTL, else null (expired entries are cleared). */
export const readPendingPartnerInvite = () => {
	try {
		const raw = localStorage.getItem(KEY);
		if (!raw) return null;
		const { token, createdAt } = JSON.parse(raw);
		if (!token || typeof createdAt !== 'number' || Date.now() - createdAt > TTL_MS) {
			localStorage.removeItem(KEY);
			return null;
		}
		return token;
	} catch {
		return null;
	}
};

export const clearPendingPartnerInvite = () => {
	try {
		localStorage.removeItem(KEY);
	} catch {
		// ignore
	}
};
